import { useTranslation } from 'react-i18next';

import { cn } from '~/utils/cn';

/**
 * Small uppercase badge that marks a simulation. Used wherever a run
 * (`isDryRun`) or an audit record (`runMode: MOCK`) must never be mistaken for a
 * real push — the contract is explicit that MOCK records are not deliveries.
 */
export function DryRunBadge({
  className,
  testId = 'dry-run-badge',
}: {
  className?: string;
  /** `data-testid` for the badge. */
  testId?: string;
}) {
  const { t } = useTranslation('deliveries');
  return (
    <span
      data-testid={testId}
      className={cn(
        'bg-muted text-muted-foreground rounded-sm px-1.5 py-0.5 text-[10px] font-semibold uppercase',
        className,
      )}
    >
      {t('detail.dryRun')}
    </span>
  );
}
